import { __ } from '@wordpress/i18n';
import { RawHTML, useState, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls,  ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody,  __experimentalUnitControl as UnitControl} from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {
    const { 
        id,
        salesNotifyInnerWidth,
        hfcNotifyMessageColor,
        hfcNotifyTimeColor,
        hfcNotifyBGColor
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfc-noti-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    const notificationData = [
        {
            imageUrl: require('../../public/img/blue-face-non-looped.gif'),
            message: 'This is the first message.',
            productName: 'Product A',
            time: '5 minutes ago',
        },
        {
            imageUrl: require('../../public/img/blue-face-non-looped.gif'),
            message: 'This is the second message.',
            productName: 'Product B',
            time: '10 minutes ago',
        },
        {
            imageUrl: require('../../public/img/blue-face-non-looped.gif'),
            message: 'This is the third message.',
            productName: 'Product C',
            time: '15 minutes ago',
        },
    ];

    const [currentNotification, setCurrentNotification] = useState(0);
    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        setShowNotification(true);
    }, []);

    const currentData = notificationData[currentNotification];

    // Defined Block Props.
    const blockProps = useBlockProps();

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/media-text',
        'core/paragraph'
    ];

    const TEMPLATE = [
        ['core/group', {
            className: 'hfc-notification-container',
        }, [
            ['core/media-text', {
                mediaType: 'image',
                mediaUrl: currentData?.imageUrl,
                mediaAlt: 'avatar',
                mediaWidth: 15,
                className: 'hfc-notification-avatar',
            }, [
                [
                    'core/paragraph',
                    {
                        content: currentData.message,
                        className: 'hfc-notification-message',
                    },
                ],
                [
                    'core/paragraph',
                    {
                        content: currentData.productName,
                        className: 'hfc-notification-product',
                    },
                ],
                [
                    'core/paragraph',
                    {
                        content: currentData.time,
                        className: 'hfc-notification-time',
                    },
                ]
            ]]
        ]]
    ];

    const hfcDynamicStyles = `.frhd__component-width-90 .components-input-control__container{
        max-width: 100%;
    }
    #${id}.hfc-notification .hfc-notification-inner{
        position: relative;
        min-width: ${salesNotifyInnerWidth};
        max-width: ${salesNotifyInnerWidth};
        background-color: ${hfcNotifyBGColor};
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);
        border-radius: 100px;
    }
    #${id}.hfc-notification .wp-block-group__inner-container,
    #${id}.hfc-notification .wp-block-media-text__content{
        padding: 0px;
    }
    #${id}.hfc-notification .hfc-close-icon{
        position: absolute;
        right: 25px;
        top: 50%;
        transform: translateY(-50%);
    }
    #${id}.hfc-notification .wp-block-media-text{
        grid-template-columns: 100px auto!important;
        gap: 10px;
    }
    #${id}.hfc-notification .wp-block-media-text__media{
        padding: 15px;
    }
     #${id}.hfc-notification .wp-block-media-text__media img{
        min-width: 90px;
        max-width: 90px;
    }
    #${id}.hfc-notification .wp-block-media-text__content p{
        font-size: 14px;
        margin: 0px;
        line-height: 20px;
    }
    #${id}.hfc-notification .hfc-notification-product{
       font-weight: bold;
    }
    #${id}.hfc-notification .hfc-notification-message{
        color: ${hfcNotifyMessageColor};
    }
    #${id}.hfc-notification .wp-block-media-text__content .hfc-notification-time{
       font-size: 10px;
       color: ${hfcNotifyTimeColor};
     }
    #${id}.hfc-notification .hfc-close-icon{
        cursor: pointer;
    }
    /* Responsive styles */
    @media (max-width: 599px){
       #${id}.hfc-notification .wp-block-media-text{
        display: flex!important;
    }
    #${id}.hfc-notification .wp-block-media-text__content p{
        font-size: 14px!important;
    }
   }
    `;

     return (
        <>
            <InspectorControls key={`inspector-controls-${id}`}>
                <PanelBody
                    title={__('Notification Block Settings')}
                    icon={'admin-generic'}
                    initialOpen={true}
                    className={'frhd__control frhd__control-query'}
                >
                <UnitControl
                    label={__('Header Inner Width :')}
                    onChange={newValue => setAttributes({ salesNotifyInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={salesNotifyInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                 <Heading className={'frhd__pb-heading'}>Notification Background Color :</Heading>
                    <ColorPalette
                        value={hfcNotifyBGColor}
                        onChange={(colorValue) => setAttributes({ hfcNotifyBGColor: colorValue })}
                        clearable={false}
                    />
                 <Heading className={'frhd__pb-heading'}>Notification Message Color :</Heading>
                    <ColorPalette
                        value={hfcNotifyMessageColor}
                        onChange={(colorValue) => setAttributes({ hfcNotifyMessageColor: colorValue })}
                        clearable={false}
                    />
                 <Heading className={'frhd__pb-heading'}>Notification Time Color :</Heading>
                    <ColorPalette
                        value={hfcNotifyTimeColor}
                        onChange={(colorValue) => setAttributes({ hfcNotifyTimeColor: colorValue })}
                        clearable={false}
                    />
                </PanelBody>
            </InspectorControls>
            <div {...blockProps}>
                <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
                {showNotification && (
                    <div id={id} className={'hfc-notification'}>
                        <div className='hfc-notification-inner'>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 384 512"
                                className="hfc-close-icon"
                                width="24"
                                height="24">
                                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                            </svg>
                            <InnerBlocks
                                allowedBlocks={ALLOWED_BLOCKS}
                                template={TEMPLATE}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export const save = ({ attributes }) => {
    const { 
        id,
        salesNotifyInnerWidth,
        hfcNotifyBGColor,
        hfcNotifyMessageColor,
        hfcNotifyTimeColor
    } = attributes;

    const hfcDynamicStyles = `#${id}.hfc-notification{
        position: relative;
        z-index: 999;
    }
   #${id}.hfc-notification .hfc-notification-inner {
        position: fixed;
        bottom: -100px;
        left: 20px;
        min-width: ${salesNotifyInnerWidth};
        max-width: ${salesNotifyInnerWidth};
        background-color: ${hfcNotifyBGColor};
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);
        border-radius: 100px;
        opacity: 0;
        transition: bottom 0.3s ease-out, opacity 0.3s ease-out;
}
#${id}.hfc-notification.show .hfc-notification-inner {
        bottom: 20px;
        opacity: 1;
}
    #${id}.hfc-notification .wp-block-group__inner-container,
    #${id}.hfc-notification .wp-block-media-text__content{
        padding: 0px!important;
    }
    #${id}.hfc-notification .hfc-close-icon{
        position: absolute;
        right: 25px;
        top: 50%;
        transform: translateY(-50%);
    }
    #${id}.hfc-notification .wp-block-media-text{
        grid-template-columns: 100px auto!important;
        gap: 10px;
    }
    #${id}.hfc-notification .wp-block-media-text__media{
        padding: 15px;
    }
    #${id}.hfc-notification .wp-block-media-text__media img{
        min-width: 90px;
        max-width: 90px;
    }
    #${id}.hfc-notification .wp-block-media-text__content p{
        font-size: 14px;
        margin: 0px;
        line-height: 20px;
    }
    #${id}.hfc-notification .hfc-notification-product{
       font-weight: bold;
    }
    #${id}.hfc-notification .hfc-notification-message{
        color: ${hfcNotifyMessageColor};
    }
    #${id}.hfc-notification .wp-block-media-text__content .hfc-notification-time{
        font-size: 10px;
        color: ${hfcNotifyTimeColor};
    }
    #${id}.hfc-notification .hfc-close-icon{
        cursor: pointer;
    }
    /* Responsive styles */
   @media (max-width: 599px){
       #${id}.hfc-notification .wp-block-media-text{
        display: flex!important;
    }
    #${id}.hfc-notification .wp-block-media-text__content p{
        font-size: 14px!important;
    }
   }`;

   const hfcNotificationScript = `
   document.addEventListener('DOMContentLoaded', function() {
       const notifications = [
           {
               message: 'This is the first message.',
               productName: 'Product A',
               time: '5 minutes ago',
           },
           {
               message: 'This is the second message.',
               productName: 'Product B',
               time: '10 minutes ago',
           },
           {
               message: 'This is the third message.',
               productName: 'Product C',
               time: '15 minutes ago',
           }
       ];
   
       let currentNotification = 0;
       const notificationElement = document.querySelector('#${id} .hfc-notification-inner');
       const notificationContainer = document.querySelector('#${id}.hfc-notification');
       const closeButton = notificationContainer.querySelector('.hfc-close-icon');
       const notificationKey = '${id}-dismissed';
   
       if (localStorage.getItem(notificationKey) === 'true') {
           notificationContainer.style.display = 'none';
           return;
       }
   
       function updateNotification() {
           const currentData = notifications[currentNotification];
           notificationElement.querySelector('.hfc-notification-message').innerText = currentData.message;
           notificationElement.querySelector('.hfc-notification-product').innerText = currentData.productName;
           notificationElement.querySelector('.hfc-notification-time').innerText = currentData.time;
   
           currentNotification = (currentNotification + 1) % notifications.length;
       }
   
       function showNotificationWithRandomDelay() {
        const randomDelay = Math.floor(Math.random() * (7000 - 2000 + 1)) + 2000; 

        setTimeout(() => {
            if (localStorage.getItem(notificationKey) === 'true') {
                return;
            }

            // Show notification
            notificationContainer.style.display = 'block';
            setTimeout(() => {
                notificationContainer.classList.add('show');
            }, 100);
            updateNotification();

            // Hide notification after 4 seconds
            setTimeout(() => {
                notificationContainer.classList.remove('show');
                setTimeout(() => {
                    notificationContainer.style.display = 'none';
                    showNotificationWithRandomDelay();
                }, 500); // Allow some time for the hide animation
            }, 4000);
        }, randomDelay);
    }
   
       // Add initial delay before showing the first notification
       const initialDelay = 2000;
       setTimeout(() => {
           showNotificationWithRandomDelay();
       }, initialDelay);
   
       // Add click event to close button
       closeButton.addEventListener('click', function() {
           notificationContainer.style.display = 'none';
           localStorage.setItem(notificationKey, 'true');
       });
   });
   `;
   
   
    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <RawHTML>{`<script>${hfcNotificationScript}</script>`}</RawHTML>
            <div id={id} className="hfc-notification" style={{ display: 'none' }}>
                <div className="hfc-notification-inner">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="hfc-close-icon"
                        width="24"
                        height="24">
                        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                    </svg>
                    <InnerBlocks.Content />
                </div>
            </div>
        </>
    );
}